import { Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Div = styled(Stack)`
  display: flex;
  justify-content: right;
  margin-right: 10px;
  margin-top: 5px;
`;